import { chargeMonthKey, formatMonthKey } from "./chargeDates";

export const FIRST_ADVISER_CHARGE_MONTH = "2026-08";

export const getAdviserChargeMonthOptions = (today = new Date(), records = []) => {
  const firstMonth = new Date(2026, 7, 1);
  const currentMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const latestRecordMonth = (Array.isArray(records) ? records : [])
    .flatMap((record) =>
      record?.billingType === "recurring"
        ? [
            record?.chargeFrom,
            record?.billingStartDate,
            record?.fromDate,
            record?.billingMonth,
            record?.date,
          ]
        : [record?.billingMonth, record?.paymentMonth, record?.date],
    )
    .map(chargeMonthKey)
    .filter(Boolean)
    .sort()
    .at(-1);
  const latestRecordDate = latestRecordMonth
    ? new Date(`${latestRecordMonth}-01T00:00:00`)
    : firstMonth;
  const finalMonth = [firstMonth, currentMonth, latestRecordDate].reduce(
    (latest, date) => (date > latest ? date : latest),
    firstMonth,
  );
  const options = [];

  for (
    const date = new Date(firstMonth);
    date <= finalMonth;
    date.setMonth(date.getMonth() + 1)
  ) {
    const id = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
    options.push({ id, name: formatMonthKey(id) });
  }

  return options.reverse();
};
